import * as React from "react";
import { Path, Rect, G, Defs, ClipPath } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const CLIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="CL" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#3D58DB"
        fillRule="evenodd"
        d="M0 0h7.2v7.2H0V0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#F7FCFF"
        fillRule="evenodd"
        d="M7-1h9v8H7v-8Z"
        clipRule="evenodd"
      />
      <Path
        fill="#E31D1C"
        fillRule="evenodd"
        d="M0 6.4h16V12H0V6.4Z"
        clipRule="evenodd"
      />
      <Path
        fill="#F7FCFF"
        fillRule="evenodd"
        d="M3.507 4.492 1.605 5.628l.939-1.933L.882 2.44 2.8 2.42 3.524.705l.466 1.713 1.817.009-1.382 1.228.718 1.972-1.636-1.136Z"
        clipRule="evenodd"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
